var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.48625 0 0 4.48625 0 10C0 15.5138 4.48625 20 10 20C15.5138 20 20 15.5138 20 10C20 4.48625 15.5138 0 10 0ZM17.3875 11.25H10.8463L8.66125 5.785L6.33875 6.715L8.15375 11.25H2.6125C2.54375 10.8425 2.5 10.4263 2.5 10C2.5 5.86375 5.86375 2.5 10 2.5C14.1362 2.5 17.5 5.86375 17.5 10C17.5 10.4263 17.4562 10.8425 17.3875 11.25Z",
    fill: "#84B0DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsage);
export default __webpack_public_path__ + "static/media/Usage.7aca05cf84701990fd4ce11b0a347b1e.svg";
export { ForwardRef as ReactComponent };